/** What the wallboard widgets share: colours, the clock format and queue names in addresses. */

export const TONE = { ok: 'var(--arc-ok)', warn: 'var(--arc-warn)', danger: 'var(--arc-danger)' } as const;
export type Tone = keyof typeof TONE;
export const worst = (...t: Tone[]): Tone => (t.includes('danger') ? 'danger' : t.includes('warn') ? 'warn' : 'ok');

export const mmss = (sec: number): string => {
  const s = Math.max(0, Math.floor(sec));
  const h = Math.floor(s / 3600); const m = Math.floor((s % 3600) / 60); const r = s % 60;
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}` : `${m}:${String(r).padStart(2, '0')}`;
};

/** A queue's name as it appears in the address: "Customer care" -> "customer-care". */
export const queueSlug = (name: string): string =>
  name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'queue';
